import { useEffect } from "react";
import { useUiStore } from "./uiStore";

/**
 * Offline detector — wires browser online/offline events into the UI store. Screens read
 * `useUiStore(s => s.online)` and render <OfflineState> (or a "données en cache" banner) when false.
 * Mount once near the root.
 */
export function useOnlineStatus(): boolean {
  const online = useUiStore((s) => s.online);
  const setOnline = useUiStore((s) => s.setOnline);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    setOnline(navigator.onLine);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, [setOnline]);

  return online;
}
